export interface JitsiUserInfo {
  displayName?: string;
  email?: string;
}

export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const payload = parts[1];
    const padLen = (4 - (payload.length % 4)) % 4;
    const padded = payload + "=".repeat(padLen);
    const json = atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function extractJitsiUserFromToken(
  token: string | null | undefined,
): JitsiUserInfo | undefined {
  if (!token) return undefined;
  const payload = decodeJwtPayload(token);
  if (!payload) return undefined;
  const ctx = payload.context as { user?: { name?: string; email?: string } } | undefined;
  const u = ctx?.user;
  if (!u) return undefined;
  return { displayName: u.name, email: u.email };
}

export function extractIsModeratorFromToken(
  token: string | null | undefined,
): boolean {
  if (!token) return false;
  const payload = decodeJwtPayload(token);
  if (!payload) return false;
  const ctx = payload.context as { user?: { moderator?: boolean | string } } | undefined;
  const m = ctx?.user?.moderator;
  return m === true || m === "true";
}

// Jitsi varsayılan toolbar'ından whiteboard çıkarılmış hâli. Kursiyer (non-moderator)
// için TOOLBAR_BUTTONS olarak set edilir — eğitmen butonu görür ve açar, kursiyer
// kendi başına açamaz ama eğitmen açtıktan sonra collaborative olarak çizebilir.
export const TOOLBAR_BUTTONS_NO_WHITEBOARD: string[] = [
  "camera",
  "chat",
  "closedcaptions",
  "desktop",
  "download",
  "embedmeeting",
  "etherpad",
  "feedback",
  "filmstrip",
  "fullscreen",
  "hangup",
  "highlight",
  "invite",
  "microphone",
  "noisesuppression",
  "participants-pane",
  "profile",
  "raisehand",
  "security",
  "select-background",
  "settings",
  "shareaudio",
  "sharedvideo",
  "shortcuts",
  "stats",
  "tileview",
  "toggle-camera",
  "videoquality",
];
